module.exports = __webpack_public_path__ + "static/img/icon-company.0113abdf.png";